export const passwordHealthTypes = {
  reusedPasswords: 'reusedPasswords',
  oldPasswords: 'oldPasswords',
  weakPasswords: 'weakPasswords',
  compromisedPasswords: 'compromisedPasswords',
};

export const passwordManagerItemScope = {
  none: 'none',
  sharedFolder: 'sharedFolder',
  user: 'user',
};

export const passwordManagerItemType = {
  password: 'password',
  twoFa: 'twoFa',
  card: 'card',
  note: 'note',
  idCard: 'idCard',
  identity: 'identity',
};

export const passwordManagerItemFieldsLabelMap = {
  [passwordManagerItemType.card]: {
    field1: 'Card Type',
    field2: 'Last 4 Digits',
  },
  [passwordManagerItemType.idCard]: {
    field1: 'Type',
    field2: '',
  },
  [passwordManagerItemType.identity]: {
    field1: 'Email',
    field2: 'Country',
  },
  [passwordManagerItemType.note]: {
    field1: '',
    field2: '',
  },
  [passwordManagerItemType.password]: {
    field1: 'Username',
    field2: 'URL',
  },
  [passwordManagerItemType.twoFa]: {
    field1: 'Associated Account Username',
    field2: 'Associated Account URL',
  },
};

export const passwordManagerItemPluralLabelMap = {
  [passwordManagerItemType.card]: 'Payment Cards',
  [passwordManagerItemType.idCard]: 'ID Cards',
  [passwordManagerItemType.identity]: 'Identities',
  [passwordManagerItemType.note]: 'Secure Notes',
  [passwordManagerItemType.password]: 'Passwords',
  [passwordManagerItemType.twoFa]: '2FAs',
};

export const passwordManagerItemTypeServerId = {
  [passwordManagerItemType.card]: 11,
  [passwordManagerItemType.idCard]: 21,
  [passwordManagerItemType.identity]: 31,
  [passwordManagerItemType.note]: 41,
  [passwordManagerItemType.password]: 1,
  [passwordManagerItemType.twoFa]: 51,
};

export const passwordManagerOS = {
  ios: 1,
  android: 2,
  desktop: 3,
};

export const passwordManagerOSLabels = [
  {
    label: 'iOS',
    os: passwordManagerOS.ios,
    icon: 'apple',
  },
  {
    label: 'Android',
    os: passwordManagerOS.android,
    icon: 'android',
  },
  {
    label: 'Desktop',
    os: passwordManagerOS.desktop,
    icon: 'apps',
  },
];

export const passwordManagerRoutes = {
  home: '/passwordmanager',
  overview: '/passwordmanager/overview',
  settings: '/passwordmanager/settings',
  sharedFolderDetails: (id) => `/passwordmanager/sharedfolders/${id}/details`,
  sharedFolders: '/passwordmanager/sharedfolders',
  userDetails: (id) => `/passwordmanager/users/${id}/details`,
  users: '/passwordmanager/users',
};

export const passwordManagerTabs = {
  overview: 'overview',
  settings: 'settings',
  sharedFolders: 'sharedfolders',
  users: 'users',
};

export const passwordManagerUserStatus = {
  active: 'Active',
  pending: 'Unverified',
  invitationResent: 'InvitationResent',
};

export const passwordStrength = {
  medium: 'medium',
  strong: 'strong',
  weak: 'weak',
};

export const passwordStrengthLabelMap = {
  [passwordStrength.medium]: 'Medium',
  [passwordStrength.strong]: 'Strong',
  [passwordStrength.weak]: 'Weak',
};

export const passwordStrengthScoreThreshold = {
  [passwordStrength.weak]: 20,
  [passwordStrength.strong]: 75,
};

export const passwordStrengthStatus = {
  [passwordStrength.weak]: 'error',
  [passwordStrength.medium]: 'warning',
  [passwordStrength.strong]: 'success',
};

export default {
  passwordManagerItemFieldsLabelMap,
  passwordManagerItemScope,
  passwordManagerItemType,
  passwordManagerItemTypeServerId,
  passwordManagerOS,
  passwordManagerOSLabels,
  passwordManagerRoutes,
  passwordManagerTabs,
  passwordManagerUserStatus,
  passwordStrength,
  passwordStrengthLabelMap,
  passwordStrengthScoreThreshold,
  passwordStrengthStatus,
};
